import { useEffect } from 'react';
import { useCanaryRequestStore } from '@/stores/canaryRequest';
import { useMedwandStore } from '@/stores/medwand';
import { useMeetingNotificationStore } from '@/stores/meetingNotification';
import { useSocketStore } from '@/stores/socket';
import { EChatEvent } from '@/types/chats';
import { ESocketListenMessageType } from '@/types/socket';

export const useActionGateway = () => {
  const { listenMessage, isConnected, stopListenMessage } = useSocketStore(
    (state) => ({
      listenMessage: state.listenMessage,
      stopListenMessage: state.stopListenMessage,
      isConnected: state.isConnected,
      sendMessage: state.sendMessage,
    }),
  );

  const removeMeeting = useMeetingNotificationStore(
    (state) => state.removeMeeting,
  );

  const setCanaryRequestAppointmentId = useCanaryRequestStore(
    (state) => state.setCanaryRequestAppointmentId,
  );

  const setMedwandRequestAppointmentId = useMedwandStore(
    (state) => state.setRequestAppointmentId,
  );
  useEffect(() => {
    if (!isConnected) return;
    listenMessage({
      type: ESocketListenMessageType.ACTION,
      callback: ({ action }) => {
        if (
          [EChatEvent.CHAT_DECLINED, EChatEvent.CHAT_ACCEPTED].includes(
            action.type,
          )
        ) {
          removeMeeting({
            chatId: action.entityId,
            participants: [],
          });
          return;
        }
        if (EChatEvent.CANARY_REQUEST === action.type) {
          setCanaryRequestAppointmentId(action.entityId);
        }
        if (EChatEvent.MEDWAND_REQUEST === action.type) {
          setMedwandRequestAppointmentId(action.entityId);
        }
      },
    });
    return () => {
      stopListenMessage(ESocketListenMessageType.ACTION);
    };
  }, [
    isConnected,
    listenMessage,
    stopListenMessage,
    removeMeeting,
    setCanaryRequestAppointmentId,
    setMedwandRequestAppointmentId,
  ]);
};
